import useGet from "../read/useGet";

const useEmployeeLeaveStructure = () => {
  const {
    list: leaveStructureList,
  } = useGet({
    url: "fetchEmployeeLeaveStructure",
    method: "get",
    initialData: {},
  });

  return {
    leaveStructureList,
    isLoading: leaveStructureList?.isLoading,
  };
};

export default useEmployeeLeaveStructure;
